/* Google Flights deep-link builder — no API needed, opens Google Flights pre-filled.
   Supports one-way, round-trip and multi-city (multi-city is parsed by Google's
   natural-language search; users may need to confirm legs on arrival). */
export const googleFlightsUrl = ({ type = "round", from, to, depart, ret, cabin, passengers, legs = [] }) => {
  let q;
  if (type === "multi") {
    const parts = legs
      .filter((l) => l.from?.trim() && l.to?.trim())
      .map((l) => `from ${l.from.trim()} to ${l.to.trim()}${l.date ? ` on ${l.date}` : ""}`);
    q = `Multi-city flights ${parts.join(", then ")}`;
  } else {
    q = `Flights from ${from} to ${to}`;
    if (depart) q += ` on ${depart}`;
    if (type === "round" && ret) q += ` through ${ret}`;
    if (type === "oneway") q += " one way";
  }
  if (cabin && cabin !== "economy") q += ` ${cabin} class`;
  if (passengers > 1) q += ` for ${passengers} passengers`;
  return `https://www.google.com/travel/flights?q=${encodeURIComponent(q)}`;
};

/* Hotel deep-links — open Google Hotels / Booking.com pre-filled for a place & dates. */
export const googleHotelsUrl = ({ place, checkin, checkout, guests }) => {
  let q = `Hotels in ${place}`;
  if (checkin) q += ` from ${checkin}`;
  if (checkout) q += ` to ${checkout}`;
  if (guests > 1) q += ` for ${guests} guests`;
  return `https://www.google.com/travel/hotels?q=${encodeURIComponent(q)}`;
};

export const bookingComUrl = ({ place, checkin, checkout, guests }) => {
  const p = new URLSearchParams({ ss: place });
  if (checkin) p.set("checkin", checkin);
  if (checkout) p.set("checkout", checkout);
  if (guests) p.set("group_adults", String(guests));
  return `https://www.booking.com/searchresults.html?${p.toString()}`;
};
